module.exports = __webpack_public_path__ + "static/fonts/iconfont.9f1eaa36.ttf";